export default __webpack_public_path__ + "static/media/women2.eafb7190.png";